export const LEADERBOARD_TABS = [
  {
    label: 'Sent',
    value: 'sent',
    sortValue: 'total_sent',
    totalValue: 'total_sent',
    blankStateLabel: 'sends',
    sortLabel: 'sends',
    isRate: false,
    icon: 'send-auto',
  },
  {
    label: 'Opened',
    value: 'opened',
    sortValue: 'opened_rate',
    totalValue: 'total_opened',
    blankStateLabel: 'opens',
    sortLabel: 'opened',
    isRate: true,
    icon: 'error',
  },
  {
    label: 'Clicked',
    value: 'clicked',
    sortValue: 'clicked_rate',
    totalValue: 'total_clicked',
    blankStateLabel: 'tracked link clicks',
    sortLabel: 'clicked',
    isRate: true,
    icon: 'cursor',
  },
  {
    label: 'Converted',
    value: 'converted',
    sortValue: 'converted_rate',
    totalValue: 'total_converted',
    blankStateLabel: 'conversions',
    sortLabel: 'converted',
    isRate: true,
    icon: 'goal',
  },
];
